"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18nify = require("react-i18nify");

var _icon = _interopRequireDefault(require("@internet-features/icon"));

var _footerColumn = _interopRequireDefault(require("./footer-column"));

var _socialMedia = _interopRequireDefault(require("./social-media"));

var _legal = _interopRequireDefault(require("./legal"));

require("./page-footer.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var PageFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(PageFooter, _React$Component);

  function PageFooter() {
    _classCallCheck(this, PageFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageFooter).apply(this, arguments));
  }

  _createClass(PageFooter, [{
    key: "render",
    // eslint-disable-next-line max-lines-per-function
    value: function render() {
      var store = this.context.store;

      var _store$getState = store.getState(),
          config = _store$getState.config;

      var footerClasses = "row justify-content-center align-items-center mx-0 mt-0 bg-dark text-light";
      return _react["default"].createElement("aside", {
        className: footerClasses
      }, _react["default"].createElement("div", {
        className: "page-footer col mt-5"
      }, _react["default"].createElement("div", {
        className: "row m-0 text-center justify-content-center justify-content-lg-start"
      }, _react["default"].createElement("p", null, _react["default"].createElement("a", {
        className: "text-light focus-outline-primary text-decoration-underline-light-solid",
        target: "_blank",
        rel: "noopener noreferrer",
        href: config.get("footer.accessibility")
      }, _react["default"].createElement(_reactI18nify.Translate, {
        value: "footer.accessibility"
      })))), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-xl-3 d-none d-xl-block"
      }, _react["default"].createElement(_footerColumn["default"], {
        title: "footer.manageAccount.title",
        items: [{
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.manageAccount.accountSummary"
          }),
          "href": "footer.manageAccount.accountSummary"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.manageAccount.billing"
          }),
          "href": "footer.manageAccount.billing"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.manageAccount.tv"
          }),
          "href": "footer.manageAccount.tv"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.manageAccount.internet"
          }),
          "href": "footer.manageAccount.internet"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.manageAccount.voice"
          }),
          "href": "footer.manageAccount.voice"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.manageAccount.mobile"
          }),
          "href": "footer.manageAccount.mobile"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.manageAccount.settings"
          }),
          "href": "footer.manageAccount.settings"
        }]
      })), _react["default"].createElement("div", {
        className: "col-xl-3 d-none d-xl-block"
      }, _react["default"].createElement(_footerColumn["default"], {
        title: "footer.support.title",
        items: [{
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.support.home"
          }),
          "href": "footer.support.home"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.support.tv"
          }),
          "href": "footer.support.tv"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.support.internet"
          }),
          "href": "footer.support.internet"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.support.voice"
          }),
          "href": "footer.support.voice"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.support.support"
          }),
          "href": "footer.support.support"
        }]
      })), _react["default"].createElement("div", {
        className: "col-xl-3 d-none d-xl-block"
      }, _react["default"].createElement(_footerColumn["default"], {
        title: "footer.watchTv.title",
        items: [{
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.watchTv.liveTv"
          }),
          "href": "footer.watchTv.liveTv"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.watchTv.guide"
          }),
          "href": "footer.watchTv.guide"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.watchTv.library"
          }),
          "href": "footer.watchTv.library"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.watchTv.onDemand"
          }),
          "href": "footer.watchTv.onDemand"
        }, {
          "content": _react["default"].createElement(_reactI18nify.Translate, {
            value: "footer.watchTv.dvr"
          }),
          "href": "footer.watchTv.dvr"
        }]
      })), _react["default"].createElement("div", {
        className: "col col-xl-3"
      }, _react["default"].createElement("div", {
        className: "row h-100 m-0"
      }, _react["default"].createElement("div", {
        className: "d-block d-lg-none flex-fill"
      }), _react["default"].createElement("div", {
        className: "d-flex flex-column flex-lg-row flex-xl-column flex-lg-grow-1 justify-content-start justify-content-lg-between justify-content-xl-start align-items-start align-items-lg-center align-items-xl-start"
      }, _react["default"].createElement("div", {
        className: "mb-3 mb-lg-0 mb-xl-3 text-nowrap mt-xl-3"
      }, _react["default"].createElement(_icon["default"], {
        name: "ki-map-point",
        style: {
          "fill": "#16bea7"
        },
        "aria-hidden": true
      }), _react["default"].createElement("a", {
        className: "text-light focus-outline-primary ml-2",
        target: "_blank",
        rel: "noopener noreferrer",
        href: config.get("footer.location")
      }, _react["default"].createElement(_reactI18nify.Translate, {
        value: "footer.location"
      }))), _react["default"].createElement("div", {
        className: "mb-3 mb-lg-0 mb-xl-3 text-nowrap"
      }, _react["default"].createElement(_icon["default"], {
        name: "ki-lightning-f",
        style: {
          "fill": "#ffd400"
        },
        "aria-hidden": true
      }), _react["default"].createElement("a", {
        className: "text-light focus-outline-primary ml-2",
        target: "_blank",
        rel: "noopener noreferrer",
        href: config.get("footer.weather")
      }, _react["default"].createElement(_reactI18nify.Translate, {
        value: "footer.weather"
      }))), _react["default"].createElement("div", {
        className: "mb-3 mb-lg-0 mb-xl-3 text-nowrap flex-xl-grow-1"
      }, _react["default"].createElement(_icon["default"], {
        name: "/assets/images/ki-bubblechat-f.svg#ki-bubblechat-f",
        style: {
          "fill": "#0073d1"
        },
        "aria-hidden": true
      }), _react["default"].createElement("a", {
        className: "text-light focus-outline-primary ml-2",
        target: "_blank",
        rel: "noopener noreferrer",
        href: config.get("footer.contact")
      }, _react["default"].createElement(_reactI18nify.Translate, {
        value: "footer.contact"
      }))), _react["default"].createElement("div", {
        className: "m-auto m-lg-0"
      }, _react["default"].createElement(_socialMedia["default"], null))), _react["default"].createElement("div", {
        className: "d-block d-lg-none flex-fill"
      })))), _react["default"].createElement(_legal["default"], null)));
    }
  }]);

  return PageFooter;
}(_react["default"].Component);

PageFooter.contextTypes = {
  "store": _propTypes["default"].object.isRequired
};
var _default = PageFooter;
exports["default"] = _default;